// @flow
import { useContext } from 'react';
import { Context, ContextType } from '../contexts/createVirtualComponentContext';

const useCreateVirtualComponentContext: () => ContextType = () => useContext(Context);
export default useCreateVirtualComponentContext;
